<div class="radio-group" role="radiogroup" [attr.aria-label]="key">
  <div
    *ngFor="let opt of options; let i = index; trackBy: trackByValue"
    class="radio-option"
    [class.selected]="radioButtonData?.value === opt.value"
    role="radio"
    [attr.aria-checked]="radioButtonData?.value === opt.value"
    [attr.tabindex]="radioButtonData?.value === opt.value ? 0 : -1"
    (click)="selectValue(opt.value)"
    (keydown)="onKeydown($event, i)"
    #radioOption
  >
    {{ opt.label }}
  </div>
</div>
